import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import { formatMoney } from "@/helpers/date-helper"
import { useScheduleSearchParams } from "@/hooks"
import { useReceivablesStore } from "@/stores"
import { DateHelper } from "@/utils"

import { ScheduleDetailsOfDateSkeleton } from "./skeleton"
export const ScheduleDetailsOfDate = () => {
  const { params } = useScheduleSearchParams()
  const receivables = useReceivablesStore(
    (state) => state.data
  )
  const receivableOfDate = receivables?.find(
    (receivable) => receivable.date === params.date
  )
  const scheduleCurrentDate = DateHelper.formatDate(
    params.date,
    "dd/MM/yyyy"
  )
  if (!scheduleCurrentDate)
    return <ScheduleDetailsOfDateSkeleton />
  return (
    <Card>
      <CardHeader>
        <CardTitle>
          Detalhes de pagamento em {scheduleCurrentDate}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <ul className="flex flex-col gap-2">
          <li className="flex flex-col justify-between gap-1 rounded-md bg-secondary p-2 sm:flex-row sm:gap-0">
            <span className="text-sm text-muted-foreground sm:text-base">
              Valor bruto dos repasses
            </span>
            <span className="text-sm font-medium sm:text-base sm:font-normal">
              {formatMoney(receivableOfDate?.value)}
            </span>
          </li>
          <li className="flex flex-col justify-between gap-1 rounded-md bg-secondary p-2 sm:flex-row sm:gap-0">
            <span className="text-sm text-muted-foreground sm:text-base">
              Taxa de transação
            </span>
            <span className="text-sm font-medium text-red-400 sm:text-base sm:font-normal">
              {formatMoney(
                receivableOfDate?.commissionValue
              )}
            </span>
          </li>
          <li className="flex flex-col justify-between gap-1 rounded-md bg-secondary p-2 sm:flex-row sm:gap-0">
            <span className="text-sm text-muted-foreground sm:text-base">
              Chargeback
            </span>
            <span className="text-sm font-medium text-red-400 sm:text-base sm:font-normal">
              {formatMoney(
                receivableOfDate?.cashbackCommissionValue
              )}
            </span>
          </li>
          <li className="flex flex-col justify-between gap-1 rounded-md bg-secondary p-2 sm:flex-row sm:gap-0">
            <span className="text-sm text-muted-foreground sm:text-base">
              Cashback
            </span>
            <span className="text-sm font-medium text-red-400 sm:text-base sm:font-normal">
              {formatMoney(receivableOfDate?.cashbackValue)}
            </span>
          </li>
          <li className="flex flex-col justify-between gap-1 rounded-md bg-gray-200 p-2 text-zinc-900 sm:flex-row sm:items-center sm:gap-0">
            <div className="flex flex-wrap items-center gap-1">
              <strong className="text-base font-semibold leading-none sm:text-lg">
                Valor líquido previsto
              </strong>
              <small className="text-xs leading-none sm:text-sm">
                (a transferir)
              </small>
            </div>
            <span className="text-base font-semibold sm:text-lg">
              {formatMoney(receivableOfDate?.netValue)}
            </span>
          </li>
        </ul>
      </CardContent>
    </Card>
  )
}
